export default "__VITE_ASSET__BLs_Qy8c__"